import useCompletedRouteMarkers from './useCompletedRouteMarkers';

export default useCompletedRouteMarkers;
